<template>
  <vue-navigation-bar 
    class="sticky-top"
    style="background-color: #d5d5d5f7; height: 62px;"
    :options="navbarOptions" 
    @vnb-item-clicked="vnbItemClicked"
  />
</template>

<script>
import * as log from 'loglevel'
//import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import VueNavigationBar from 'vue-navigation-bar';

export default {
  name: 'MainNavBar',
  components: {
    //FontAwesomeIcon,
    'vue-navigation-bar': VueNavigationBar
  },
  data() {
    return {
      //faCaretDown,
      navbarOptions: {
        elementId: "main-navbar",
        isUsingVueRouter: true,
        mobileBreakpoint: 992,
        brandImagePath: "/",
        brandImage: require("../../src/assets/images/gmx_logo_2020.png"),
        brandImageAltText: "Graphmetrix logo",
        collapseButtonOpenColor: "#661c23",
        collapseButtonCloseColor: "#661c23",
        showBrandImageInMobilePopup: true,
        ariaLabelMainNav: "Main Navigation",
        tooltipAnimationType: "shift-away",
        tooltipPlacement: "bottom",
        menuOptionsLeft: [
          {
            type: "link",
            text: "Products",
            subMenuOptions: [
              {
                type: "link",
                text: "Oracle Aconex Accelerator",
                subText: "",
                path: { name: "Aconex" },
                iconLeft: '<img src=' + require('../assets/accelerator-logo-32px.png') + ' alt="Oracle Accelerator icon" style="height: 32px;">',
              },
              {
                type: "link",
                text: "TrinPod\u2122 Server",
                subText: "",
                path: { name: "TrinPodServer" },
                iconLeft: '<img src=' + require('../assets/trinity_secure.png') + ' alt="TrinPod\u2122 icon" style="height: 32px;">',
              },
              {
                type: "link",
                text: "TrinApp\u2122 Suite",
                subText: "",
                path: { name: "trinapp" },
                iconLeft: '<img src=' + require('../assets/launchpad.png') + ' alt="TrinApp\u2122 Suite icon" style="height: 32px;">',
              },
            ]
          },
          {
            type: "link",
            text: "Solutions",
            subMenuOptions: [
              {
                type: "link",
                text: "Building",
                subText: "AECO: Architecture, Engineering, Construction & Operations",
                //path: { name: "Building" },
                path: { name: "Aconex" },
                iconLeft: '<img src=' + require('../assets/trinity_construction.png') + ' alt="Building icon" style="height: 32px;">',
              },
              {
                type: "link",
                text: "Property",
                subText: "A single source for document management and control",
                //path: { name: "Property" },
                path: { name: "Aconex" },
                iconLeft: '<img src=' + require('../assets/trinity_properties_hat.png') + ' alt="Property icon" style="height: 32px;">',
                
              },
              {
                type: "link",
                text: "Productivity",
                subText: "Productivity Solid server and apps",
                //path: { name: "Productivity" },
                path: { name: "trinapp" },
                iconLeft: '<img src=' + require('../assets/trinity.png') + ' alt="Productivity icon" style="height: 32px;">',
              },
            ]
          },
          {
            type: "link",
            text: "Company",
            subText: "Company",
            path: { name: "company" },
            subMenuOptions: [
              {
                type: "link",
                text: "About Graphmetrix",
                //subText: "Our mission",
                path: { name: "about" },
                iconLeft: '<img src=' + require('../assets/g_logo.png') + ' alt="Graphmetrix icon" style="height: 32px;">',
              },
              {
                isLinkAction: true,
                type: "link",
                text: "Contact Us",
                path: '',
              },
              {
                type: "link",
                text: "Privacy",
                path: { name: "privacy" },
              },
              {
                type: "link",
                text: "Terms of Service",
                path: { name: "terms" },
              },
            ]
          },
          {
            isLinkAction: true,
            type: "link",
            text: "Pricing",
            path: '',
          }
        ],
        menuOptionsRight: [
          {
            isLinkAction: true,
            type: "button",
            text: "Book Demo",
            path: '',
            class: "btn-light"
          },
          {
            isLinkAction: true,
            type: "button",
            text: "Get started",
            path: '',
            class: "btn-get-started",
            //iconRight: '<svg id="i-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"> <path d="M22 6 L30 16 22 26 M30 16 L2 16" /> </svg>'
          },
          {
            isLinkAction: true,
            type: "button",
            text: "Login",
            path: '',
            class: "btn-light"
          },
        ]
      }
    }
  },
  methods: {
    scrollToTop: function () {
	    window.scrollTo(0,0);
	  },
    vnbItemClicked(text) {
      /*if (text === "Footer") {
        console.log("'Footer' was selected.");
        const element = document.getElementById("footer");
        element.scrollIntoView({
          behavior: "smooth"
        });
      }*/
      if (text === "Pricing") {
        window.open('https://trinapp.com/pricing', '_self');
      }
      if (text === "App Developers") {
        window.open('/developer', '_self');
      }
      if (text === "Get started" || text === "Login") {
        //window.open('https://forms.zohopublic.com/graphmetrix/form/TrinAppProjectsEarlyAccessWaitList/formperma/uQZjDY2CZjT85rjwA0I1NmTa4-ueyTaba42g4DsE6sk', '_self')
        window.open('https://trinapp.com', '_self');
      }
      if (text === "Contact Us") {
        window.open('https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s', '_self')
      }
      if (text === "Book Demo") {
        window.open('https://graphmetrix.zohobookings.com/#/customer/kai', '_blank');
      }
      if (text !== "App Developers" || text !== "Get started" || text !== "Login" || text !=="Contact Us") {
        this.scrollToTop();
      }
      if (text === "TrinPod\u2122") {
        window.open('/trinpod-server#trinpod', '_self');
      }
      if (text === "Crosslink") {
        window.open('/trinpod-server#crosslink', '_self');
      }
      if (text === "Search API") {
        window.open('/trinpod-server#search-api', '_self');
      }
      if (text === "Versioning") {
        window.open('/trinpod-server#versioning', '_self');
      }
      if (text === "Solid W3C API") {
        window.open('/trinpod-server#what-is-solid', '_self');
      }
      if (text === "Pods") {
        window.open('/trinapp#pods', '_self');
      }
      if (text === "Documents") {
        window.open('/trinapp#documents', '_self');
      }
      if (text === "Digital Twin") {
        window.open('/trinapp#digital-twin', '_self');
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--style scoped>
.vnb .button-red {
  background: #ff3b30;
}
.vnb .button-red:hover {
  background: #fc0d00;
}
</style-->

<style>
.vnb .btn-get-started {
  background-color: #585aff;
}
@media (min-width: 992px) {
  .vnb .btn-get-started:hover {
    background-color: #08034c;
  }
}
.vnb__popup__bottom__sub-menu-options__option__link__sub-text {
  display: none; /* turns off sub-text on mobile */
}
.vnb__popup__bottom__menu-options__option__link.btn-get-started {
  color: #212529;
  background-color: #f8f9fa;
}
/*[aria-label="TrinPod™ Server"], [aria-label="TrinApp™ Suite"] {
  font-weight: 600;
  font-size: 1.1rem;
}*/
</style>
